import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PartnersRoutes: Routes = [
  {
    path: "partners",
    loadComponent: () =>
      import("./partners/partners.component").then((m) => m.PartnersComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./partners-list/partners-list.component").then(
            (m) => m.PartnersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./partners-form/partners-form.component").then(
            (m) => m.PartnersFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./partners-form/partners-form.component").then(
            (m) => m.PartnersFormComponent,
          ),
      },
    ],
  },
];
